import Vue from 'vue';
import app from './app';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import { BootstrapVue, BootstrapVueIcons, IconsPlugin } from 'bootstrap-vue';
import VueToastr from 'vue-toastr';
import vSelect from 'vue-select';
import { Plugin } from 'vue-fragment';

import 'sanitize.css/sanitize.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-select/dist/vue-select.css';
import './assets/css/globalStyle.scss';

import mixin from './mixin';

Vue.component('v-select', vSelect);

Vue.use(VueToastr, {
  defaultProgressBar: true,
  defaultCloseOnHover: true,
});

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(IconsPlugin);
Vue.use(Plugin);

// mixin
Vue.mixin(mixin);

Vue.config.productionTip = false;

async function reloadUser() {
  let user = window.localStorage.getItem('lecle-reviews-current-user');

  if (!user) return;
  user = atob(user);
  user = JSON.parse(user);

  store.commit('app/user', user);
}

reloadUser()
  .then(() => {
    const vue = new Vue({
      router,
      store,
      render: h => h(App),
    }).$mount('#app');

    app.setVue(vue);
  })
  .catch(err => {
    console.error('---- reloadUser', err);
  });
